const educationMessagePath = 'educationHub.';
const educationTabPath = educationMessagePath + 'mainTabLabels.';

const educationTrans = {
    BANNER_TITLE : educationMessagePath + 'bannerTitle',
    BANNER_DESCRIPTION : educationMessagePath + 'bannerDescription',

    ABOUT_GA_LABEL:educationTabPath + 'aboutGA',
    IMAGING_LABEL:educationTabPath + 'imaging',
    MANAGEMENT_LABEL:educationTabPath + 'management',
    RESOURCES_LABEL:educationTabPath + 'resource'
}

export default educationTrans